'use strict';

angular.module('shiftTraderApp')
  .factory('Media', function (ServerUrls, $http, $q, Session, UserPermissionsService) {
    function getBaseUrl() {
      return ServerUrls.current.railsApi + 'organizations/' + Session.getCurrentOrgId() + '/media/';
    }

    // Fetch permissions
    var permissionsToFetch = [
      'media.view_public',
      'media.update_mine',
      'media.view_management',
      'media.create',
      'media.view_admin',
      'media.update_others',
      'media.destroy'
    ];

    //the Model
    var Media = function(initData) {
      var M = {};
      angular.extend(M, initData);

      function processRawPermissions(rawPerms) {
        var isMyNote = M.user.id == Session.me;
        var myPermLevel = (rawPerms['media.view_public']) ? 0 : -1;
        myPermLevel = (rawPerms['media.view_management']) ? 1 : myPermLevel;
        myPermLevel = (rawPerms['media.view_admin']) ? 2 : myPermLevel;

        M._permissions = {
          canEdit: rawPerms['media.update_others'] || isMyNote && rawPerms['media.update_mine'],
          canCreate: rawPerms['media.create'],
          canDelete: rawPerms['notes.destroy'] || false, // SATODO: Need to add in the time limit counter here. 5min grace period
          canView: M.permission <= myPermLevel,
          myPermLevel: myPermLevel
        };


        // SATODO: I don't think this should really be here... let's move this to saNote or wherever would need to know this
        // N._permissions.needsContextMenu = N._permissions.canEdit || N._permissions.canDelete;
      }

      M.generateUrl = function() {
        var res = null;
        switch (M.service_type) {
          case 'filestack':
            res = 'https://cdn.filestackcontent.com/' + M.external_id;
            break;
          case 'youtube':
            res = 'http://youtube.com/watch?v=' + M.external_id;
            break;
          case 'vimeo':
            res = 'http://vimeo.com/' + M.external_id;
            break;
        }

        return res;
      };

      M.track = function(type, uuid, currentTime, duration) {
        var payload = {
          session_uuid: uuid,
          engagement_type: type
        };
        
        if (type == 'play') {
          $http.post(getBaseUrl() + M.id + '/media_engagements', payload)
            .then(function(response) {
              console.log('Successfully Tracked Play Engagement', response);
            }, function(response) {
              console.log('Failed to Track Play Engagement', response);
            });
        } else if (type == 'progress') {
          var percent = (currentTime / duration) || 0.0;
          payload['seconds_played'] = currentTime;
          payload['percent_played'] = percent;

          $http.post(getBaseUrl() + M.id + '/media_engagements', payload)
            .then(function(response) {
              console.log('Successfully Tracked Engagement', response);
            }, function(response) {
              console.log('Failed to Track Engagement', response);
            });
        } else if (type == 'download') {
          // To do
        }
      };

      M.$getPermissions = function() {
        var deferred = $q.defer();

        if (M._permissions) {
          deferred.resolve(M._permissions);
        } else {
          UserPermissionsService.getCanDict(permissionsToFetch, M.organization_id || 'current')
            .then(function(dikt) {
              processRawPermissions(dikt);

              deferred.resolve(M._permissions);
            }, function() {
              deferred.reject();
            });
        }

        return deferred.promise;
      };

      return M;
    };


    var Medias = {};
    Medias.getGeneralPermissions = function(orgId) {
      return UserPermissionsService.getCanDict(permissionsToFetch, orgId || 'current');
    };

    Medias.getById = function(id) {
      return $http.get(getBaseUrl() + id)
        .then(function(response) {
          return new Media(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Medias.getAll = function(data) {
      var config = {};
      if (data) {
        config = {
          params: data
        };
      }

      return $http.get(getBaseUrl(), config)
        .then(function(response) {
          return _.map(response.data, function(dept) {
            return new Media(dept);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    // Notes.create = function(data) {
    //   return $http.post(getBaseUrl(), data)
    //     .then(function(response) {
    //       return new Note(response.data);
    //     }, function(response) {
    //       return $q.reject(response);
    //     });
    // };

    Medias.initWithData = function(initData) {
      return new Media(initData);
    };

    Medias.initNew = function() {
      return Medias.initWithData({
        message: '',
        user: Session.me
      })
    }

    // Notes.destroy = function(noteId) {
    //   return $http.delete(getBaseUrl() + noteId)
    //     .then(function(response) {
    //       console.log("Deleted Note: " + noteId);
    //     }, function(response) {
    //       return $q.reject(response);
    //     })
    // }

    return Medias;
  });
